// Re-create an in-memory file: Safari can lose disk-backed multipart bodies
// after a native capture, IndexedDB round-trip or tab suspension.
export async function readableOriginal(file, name) {
  if (!file || typeof file.arrayBuffer !== "function" || !file.size) throw new Error("De originele foto is niet leesbaar. Kies dezelfde foto opnieuw; je concept blijft bewaard.");
  let bytes;
  try { bytes = await file.arrayBuffer(); }
  catch { throw new Error("Deze foto kan niet meer van dit apparaat worden gelezen. Kies dezelfde foto opnieuw; je concept blijft bewaard."); }
  if (bytes.byteLength !== file.size) throw new Error("De foto is niet volledig ingelezen. Kies dezelfde foto opnieuw; je concept blijft bewaard.");
  return new File([bytes], name || file.name || "productfoto.jpg", { type: file.type || "application/octet-stream", lastModified: file.lastModified || Date.now() });
}

export const photoError = (error) => {
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.some((item) => item.loc?.includes("file") || item.msg === "Field required")) return "De foto is niet volledig verstuurd. Je origineel is bewaard. Druk op Opnieuw versturen.";
  return error.response ? "De foto kon niet worden verstuurd. Je origineel is bewaard; probeer opnieuw." : error.message || "Geen verbinding. Je foto blijft bewaard op dit apparaat.";
};